<template>
  <v-container class="text-center">
    <v-row justify="center">
      <v-col cols="12" md="8">
        <base-material-card color="secondary" class="" :title="$t('meeting_minutes')"
          icon="mdi-book-open-outline justify-center text-center">
          <v-layout>
            <v-tabs v-if="!$vuetify.breakpoint.smAndDown" v-model="typeDoc" color="secondary" slider-color="secondary" fixed-tabs>
              <v-tab class="mr-3">
                <v-icon class="mr-2">mdi-handshake-outline</v-icon>
                {{ $t('membership_affiliation') }}
              </v-tab>
              <v-tab class="mr-3">
                <v-icon class="mr-2">mdi-exit-run</v-icon>
                {{ $t('membership_radiation') }}
              </v-tab>
            
              <v-tab class="mr-3">
                <v-icon class="mr-2">mdi-piggy-bank-outline</v-icon>
                {{ $t('financial_statement') }}
              </v-tab>
              <v-tab class="mr-3">
                <v-icon class="mr-2">mdi-book-account-outline</v-icon>
                {{ $t('mebers_book') }}
              </v-tab>
            </v-tabs>
            <div v-else class="mobileTabsMenu">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="secondary" block v-bind="attrs" v-on="on">
                    <v-icon left>{{ mobileTabs[typeDoc] ? mobileTabs[typeDoc].icon : 'mdi-book-open-outline' }}</v-icon>
                    {{ mobileTabs[typeDoc] ? mobileTabs[typeDoc].label : $t('meeting_minutes') }}
                    <v-icon right>mdi-menu-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item v-for="(item, index) in mobileTabs" :key="index" @click="typeDoc = index">
                    <v-icon class="mr-2">{{ item.icon }}</v-icon>
                    <v-list-item-title>{{ item.label }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </v-layout>
          <v-container style="margin-top: 10px;">
            <v-row v-if="typeDoc === 3">
              <v-col>
               <v-select v-model="selectedEsercizio" :items="listEsercizi" item-text="season" item-value="annoCurEse"
                  :menu-props="{ maxHeight: '400' }" :label="$t('accounting_exercise')" required color="primary"
                  :hint="$t('pick_accounting_exercise')" persistent-hint></v-select>
              </v-col>
              <v-col>
                <my-datepicker v-model="datePrt" :label="$t('date_print')" required="true" />
              </v-col>
              </v-row>
            <v-row v-else>
              <v-col md="4" cols="6" v-if="typeDoc === 2">
                <v-select v-model="selectedEsercizio" :items="listEsercizi" item-text="season" item-value="annoCurEse"
                  :menu-props="{ maxHeight: '400' }" :label="$t('accounting_exercise')" required color="primary"
                  :hint="$t('pick_accounting_exercise')" persistent-hint></v-select>
              </v-col>
              <v-col md="2" cols="6" v-if="typeDoc === 0 || typeDoc === 1">
                <my-datepicker v-model="dateInz" :label="$t('date_inz')" required="true" />
              </v-col>
              <v-col md="2" cols="6" v-if="typeDoc === 0 || typeDoc === 1">
                <my-datepicker v-model="dateEnd" :label="$t('date_end')" required="true" />
              </v-col>
              <v-col offset-md="2" md="2" cols="4">
                <v-select  v-if="typeDoc === 0 || typeDoc === 1" v-model="daysBetween" :items="daysBetweenSelect" item-text="dex" item-value="day"
                  :menu-props="{ maxHeight: '400' }" :label="$t('days_range')" required color="primary"
                  :hint="$t('select_days_between_verbal')" persistent-hint></v-select>
                  <my-datepicker v-else v-model="datePrt" :label="$t('date_print')" required="true" />
              </v-col>
              <v-col md="2" cols="4">
                <my-timepicker v-model="timePrtInz" :label="$t('time_inz')" required="true" />
              </v-col>
              <v-col md="2" cols="4">
                <my-timepicker v-model="timePrtEnd" :label="$t('time_end')" required="true" />
              </v-col>
              <v-col cols="12">
                <v-select v-model="president" :items="selectUser" chips :label="$t('president')"></v-select>
              </v-col>
              <v-col cols="12">
                <v-select v-model="secretary" :items="selectUser" chips :label="$t('secretary')"></v-select>
              </v-col>
              <v-col cols="12">
                <v-select v-model="executive" :items="selectUser" multiple chips :label="$t('executive')"></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="text-center">
                <v-btn @click="generaVerbali(typeDoc)" color="success">{{
                  $t("generate_doc")
                }}</v-btn>
              </v-col>

            </v-row>
          </v-container>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import Swal from "sweetalert2";
import MyDatepicker from "@/components/base/MyDatepicker.vue";
import MyTimepicker from "@/components/base/MyTimepicker.vue";

export default {
  name: "affiliazione",
  components: { MyDatepicker, MyTimepicker },
  computed: {
    mobileTabs() {
      return [
        { icon: "mdi-handshake-outline", label: this.$t("membership_affiliation") },
        { icon: "mdi-exit-run", label: this.$t("membership_radiation") },
        { icon: "mdi-piggy-bank-outline", label: this.$t("financial_statement") },
        { icon: "mdi-book-account-outline", label: this.$t("mebers_book") },
      ];
    },
  },
  data() {
    return {
      selectUser: [],
      president: null,
      dateInz: null,
      dateEnd: null,
      datePrt: null,
      daysBetween: 7,
      daysBetweenSelect: [{day: 7, dex: this.$t('one_week')},{day: 14, dex: this.$t('two_week')},{day: 28, dex: this.$t('four_week')}],
      selectedEsercizio: null,
      typeDoc: 0,
      listEsercizi: [],
      timePrtInz: null,
      timePrtEnd: null,
      secretary: null,
      executive: [],
    };
  },

  methods: {
    loadEsercizi() {
      // Recupera esercizi
      let _ = this;
      _.listEsercizi = [];
      this.chiamataAxios("GET", "auth/contab/listEsercizi").then((response) => {
        _.listEsercizi = response.data.listEsercizi;
        _.selectedEsercizio = response.data.curEsercizio.annoCurEse;
        _.dateInz = response.data.curEsercizio.dataInzEse;
        _.dateEnd = response.data.curEsercizio.dataFinEse;
      });
    },
    generaVerbali(type) {
      let _ = this;
      let params = {
        dateInz: _.dateInz,
        dateEnd: _.dateEnd,
        daysBetween: _.daysBetween,
        datePrt: _.datePrt,
        timeInz: _.timePrtInz,
        timeEnd: _.timePrtEnd,
        idPresidente: _.president,
        idSegretario: _.secretary,
        idConsiglieri: _.executive,
      };
      let queryString = this.getQueryString(params);
      let url = ""
      if (type === 0) url = "/auth/tesseramenti/pdf/richiesteAffiliazione/affiliation?" + queryString;
      if (type === 1) url = "/auth/tesseramenti/pdf/richiesteAffiliazione/radiation?" + queryString;
      if (type === 2) url = "/auth/contab/pdf/getVerbaleRendiconto/" + _.selectedEsercizio + "?" + queryString;
      if (type === 3) url = "/auth/tesseramenti/pdf/libroSoci/" + _.selectedEsercizio + "?" + queryString;
      url = this.authorizeLink(url);
      window.open(url);
    },
    getSelectFormat(user) {
      return user.map(function (utente) {
        return { value: utente.masterId, text: utente.name + " " + utente.surname };
      });
    },
    getIdFormat(user) {
      if (user && Array.isArray(user) && user.length > 0) return user[0].masterId;
      else return null;
    },
    getIdFilteredFormat(user) {
      let _ = this;
      if (user && Array.isArray(user) && user.length > 0) {
        let executivesUser = user.filter((utente) => {
          return _.president !== utente.masterId && _.secretary !== utente.masterId;
        });
        if (executivesUser.length > 0) {
          return executivesUser[0].masterId;
        } else {
          return null;
        }
      } else {
        return null;
      }
    },
    loadUsers() {
      let _ = this;
      let url = "/auth/portal/listUsersByExecutiveRole";
      _.selectUser = [];
      _.president = null;
      _.secretary = null;
      _.daysBetween = 7;
      _.datePrt = null;
      _.dateInz = null;
      _.dateEnd = null;
      _.timeTes = 13;
      _.executive = [];
      this.chiamataAxios("GET", url).then((response) => {
        // Aggiunge actions e icona validazione
        let adesso = new Date();
        _.selectUser = _.getSelectFormat(response.data.all);
        _.president = _.getIdFormat(response.data.president);
        _.secretary = _.getIdFormat(response.data.secretary);
        _.executive = _.getIdFilteredFormat(response.data.executive);
        _.datePrt = adesso.toISOString();
        _.timePrtInz = adesso.toISOString();
        _.timePrtEnd = new Date(
          adesso.getTime() + 2 * 60 * 60 * 1000
        ).toISOString();
        _.dateInz = response.data.esercizio.dataInzEse;
        _.dateEnd = response.data.esercizio.dataFinEse;
      });
    },
  },
  mounted() {
    this.typeDoc = parseInt(this.$route.query.tab, 10) || 0;
    this.loadUsers();
    this.loadEsercizi();
  },
  watch: {
    typeDoc(value) {
      // mantiene la tab corrente nell'URL per sopravvivere al reload della pagina
      this.$router
        .replace({ query: { ...this.$route.query, tab: value } })
        .catch((err) => {
          if (err.name !== "NavigationDuplicated") throw err;
        });
    },
  },
};
</script>
<style>
.mobileTabsMenu {
  width: 100%;
  margin-bottom: 12px;
}
.mobileTabsMenu .v-menu {
  display: block;
  width: 100%;
}
</style>